import { render, staticRenderFns } from "./px-avatar-set.vue?vue&type=template&id=cd5145dc&scoped=true&"
import script from "./px-avatar-set.vue?vue&type=script&lang=ts&"
export * from "./px-avatar-set.vue?vue&type=script&lang=ts&"
import style0 from "./px-avatar-set.vue?vue&type=style&index=0&id=cd5145dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5145dc",
  null
  
)

export default component.exports